/*
This file is an entrypoint for `@cimpress-ui/react/date`.

We re-export the `@internationalized/date` package because:
- `react-aria-components` specifies it as a dependency, and can bump its version at any time
- we don't want this package as a peer dependency, because then we would have to release a new major version of `@cimpress-ui/react`
  after every version bump of `react-aria-components`
- we don't want consumers to install this package themselves, as it would quickly lead to version mismatches
*/

export * from '@internationalized/date';
